<ng-template #template>
    <svc-page-wrapper [page]="model.pagesController.page2Display" [creator]="creator" [isGhost]="model.pagesController.page2Display == model.newPage" [className]="'svc-page'"></svc-page-wrapper>
</ng-template>